module.exports = __webpack_public_path__ + "static/electronic-6a3eed144980a838761e2f9903b12792.png";